(ns pfo.coltype.spec
  #_(:require
   [malli.core :as m]))

(defn atom? [value] (satisfies? IDeref value))

(def field
  [:map
   [:ref :string]
   [:type :string]])

(def form-field-options-spec
  [:map
   [:value-atoms [:map-of :string :any]]
   [:shared-atom :any]
   [:value-atom :any]
   ;; [:deleted-value-atom [:fn atom?]]
   [:form-fields [:vector field]]
   [:all-segment-ref-field-map [:map-of :string field]]
   [:skip-change-atom :any]
   [:rerender-atom [:fn atom?]]
   [:data-sources :any]
   [:add_contact_user [:fn fn?]]
   [:errors-atom :any]
   [:objects [:map-of :string :any]]
   [:shared-atoms [:map-of :string :any]]])


(def document-field-options-spec
  [:and
   form-field-options-spec
   [:map
    [:permitted-groups [:maybe [:vector :any]]]
    [:deleted-value-atom [:fn atom?]]]])
